import {Box, Typography} from '@mui/material';

import {greenColors, orangeColors} from '../../layouts/theme/designSystem';

export interface EmpionMatchScoresGridItem {
  key: string;
  label: string;
  value: string;
}

type Variant = 'small' | 'default';

interface Props {
  items: EmpionMatchScoresGridItem[];
  ariaLabel?: string;
  variant?: Variant;
}

const scoreBreakdownGroupSxByVariant: Record<Variant, Record<string, unknown>> = {
  small: {
    display: 'inline-flex',
    flexDirection: 'row',
    mt: 0.5,
    border: `1px solid ${orangeColors[3]}`,
    borderRadius: '6px',
    overflow: 'hidden',
    bgcolor: 'white',
    maxWidth: '100%',
    '@container (max-width: 420px)': {
      display: 'flex',
      width: '100%',
      mt: 0,
    },
  },
  default: {
    display: 'inline-flex',
    flexDirection: 'row',
    mt: 0.5,
    border: `1px solid ${orangeColors[3]}`,
    borderRadius: '8px',
    overflow: 'hidden',
    bgcolor: 'white',
    maxWidth: '100%',
    '@container (max-width: 420px)': {
      display: 'flex',
      width: '100%',
      mt: 0,
    },
  },
};

const scoreBreakdownCellSx = (index: number, total: number, variant: Variant) => ({
  px: variant === 'small' ? 1.5 : 2,
  py: variant === 'small' ? 1 : 1.25,
  minWidth: variant === 'small' ? 0 : 76,
  flex: variant === 'small' ? '1 1 0' : '0 0 auto',
  textAlign: 'center' as const,
  borderRight: index < total - 1 ? `1px solid ${orangeColors[3]}` : 'none',
});

export const EmpionMatchScoresGrid = ({items, ariaLabel, variant = 'default'}: Props) => (
  <Box component='div' role='group' aria-label={ariaLabel} sx={scoreBreakdownGroupSxByVariant[variant]}>
    {items.map((item, index) => {
      const isTotal = item.key === 'total';
      return (
        <Box key={item.key} sx={scoreBreakdownCellSx(index, items.length, variant)}>
          <Typography
            component='span'
            sx={{
              display: 'block',
              fontSize: variant === 'small' ? '10px' : '11px',
              lineHeight: 1.1,
              color: greenColors[600],
              fontWeight: 600,
            }}
          >
            {item.label}
          </Typography>
          <Typography
            component='span'
            sx={{
              display: 'block',
              fontSize:
                variant === 'small' ? (isTotal ? '15px' : '13px') : isTotal ? '17px' : '15px',
              fontWeight: isTotal ? 800 : 700,
              color: isTotal ? orangeColors[900] : greenColors[700],
              lineHeight: isTotal ? 1.15 : 1.2,
            }}
          >
            {item.value}
          </Typography>
        </Box>
      );
    })}
  </Box>
);
